export enum MessageType {
  Facebook = 'facebook',
  Instagram = 'instagram',
  Line = 'line',
  Sms = 'sms',
  Twitter = 'twitter',
  WebMessaging = 'webmessaging',
  WhatsApp = 'whatsapp'
}
